import type { LocalizedText } from '@fitting-room/contracts'

/**
 * Locale resolution, mirroring `resolveText` in the contracts package.
 *
 * It is reimplemented here rather than imported so that the client never pulls
 * the zod schema module graph into the browser bundle for the sake of a
 * three-line string lookup. The types still come from the contract.
 */
export function text(value: LocalizedText | undefined, locale?: string): string {
  if (!value) return ''
  if (locale) {
    const translated = value.translations?.[locale]
    if (translated) return translated
  }
  return value.default
}

/** First grapheme of a label, for the monogram fallback in the icon registry. */
export function initial(label: string): string {
  const trimmed = label.trim()
  if (!trimmed) return '·'
  return [...trimmed][0] ?? '·'
}
